module.exports = __webpack_public_path__ + "static/media/bannerHomeMarzo.3101faa0.jpg";